// 录单界面的表头左右键盘事件
export function queryFormLeftOrRight(selfRef, nextOrPrevRef) {
  if (selfRef && selfRef.$children.length) {
    selfRef.$children[0].blur();
  }
  nextOrPrevRef.$children[0].focus();
}

// 找到最后一个
export function getLastElementForArr(arr = [], key = "") {
  let index = -1;
  for (let i = arr.length - 1; i >= 0; i--) {
    if (typeof key == "function" ? key(arr[i]) : arr[i][key]) {
      index = i;
      break;
    }
  }
  return index;
}

// 找到下一个
export function getNextElementForArr(arr = [], key = "", initialIndex = 0) {
  let index = -1;
  for (let i = initialIndex; i < arr.length; i++) {
    if (typeof key == "function" ? key(arr[i]) : arr[i][key]) {
      index = i;
      break;
    }
  }
  return index;
}
// 找到上一个
export function getPrevElementForArr(
  arr = [],
  key = "",
  initialIndex = arr.length - 1
) {
  let index = -1;
  for (let i = initialIndex; i >= 0; i--) {
    if (typeof key == "function" ? key(arr[i]) : arr[i][key]) {
      index = i;
      break;
    }
  }
  return index;
}
